// extracted by mini-css-extract-plugin
export default {"guide_main":"Sign_guide_main__M+DPt"};